import { wrap } from 'comlink'
import { RoleMimetype, getApiUrl } from 'constants/API'
import { LoadEditedVisualResult } from 'models/visualsEditing'
import API from 'utils/API/API'
import { auth0ClientModule } from 'utils/auth'
import { loadEditedVisualWorkerType } from 'workers/loadEditedVisualWorker'

// Initiates workers for thumbnails for Visual Editing
const initWorkers = () => {
  const workerCount = process.env.NODE_ENV === 'test'
    ? 0
    : navigator.hardwareConcurrency || 4

  const workerPool = [...Array(workerCount).keys()]
    .map(() => {
      const worker = new Worker(
        new URL('workers/loadEditedVisualWorker', import.meta.url),
        {
          type: 'module',
        }
      )

      return wrap<loadEditedVisualWorkerType>(worker)
    })

  let i = 0
  /** Calls loadEditedVisualWorker */
  return (action: LoadEditedVisualResult, token: string, mimetype: RoleMimetype, apiUrl: string) => {
    const result = workerPool[i](action, token, mimetype, apiUrl)
    i = ++i % workerCount
    return result
  }
}

/** Calls loadEditedVisualWorker */
const getWorkDone = initWorkers()

export const runWorker = async (action: LoadEditedVisualResult) => {
  // needed to make exception for environment where we run all tests
  if (process.env.NODE_ENV === 'test') return

  const token = await auth0ClientModule.getTokenSilently()
  const mimetype = await API.getRoleMimeType()

  return await getWorkDone(action, token, mimetype, getApiUrl())
}
